import { useState, useCallback } from 'react';
import { format } from 'date-fns';
import { searchSampleUserTypes as searchSampleUserTypesService, type SampleUserTypeSearchParams, type SampleUserType } from '../services/sampleUserTypeService';
import { useAuth } from '@/features/auth/';

export const useSampleUserTypes = () => {
  const [sampleUserTypes, setSampleUserTypes] = useState<SampleUserType[]>([]);
  const [loading, setLoading] = useState(false);
  const { user } = useAuth();

  const searchSampleUserTypes = useCallback(async (criteria: {
    dateFrom?: Date;
    dateTo?: Date;
    sampleTypeId?: number;
    userId?: number;
    status?: string;
    observations?: string;
  }) => {
    if (!user?.id) {
      throw new Error('Usuario no autenticado');
    }

    setLoading(true);
    try {
      const searchParams: SampleUserTypeSearchParams = {
        sampleDateFrom: criteria.dateFrom ? format(criteria.dateFrom, 'yyyy-MM-dd') : undefined,
        sampleDateTo: criteria.dateTo ? format(criteria.dateTo, 'yyyy-MM-dd') : undefined,
        sampleTypeId: criteria.sampleTypeId,
        userId: criteria.userId,
        status: criteria.status,
        observations: criteria.observations,
      };

      const results = await searchSampleUserTypesService(searchParams);
      setSampleUserTypes(results);
    } catch (error) {
      console.error('Error al buscar tipos de usuario de muestras:', error);
      throw error;
    } finally {
      setLoading(false);
    }
  }, [user?.id]);

  return {
    sampleUserTypes,
    loading,
    searchSampleUserTypes
  };
}; 